import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Clock } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';

const APP_LOGO_URL = process.env.REACT_APP_LOGO_URL || '/logo192.png';

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-card border-t border-border mt-24">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img src={APP_LOGO_URL} alt="El Rincón de Camo" className="w-12 h-12 rounded-full object-cover" />
              <span className="text-foreground font-bold text-lg" style={{ fontFamily: 'Cinzel, serif' }}>El Rincón de Camo</span>
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
              {t('footer.tagline')}
            </p>
            <div className="mt-4 space-y-2 text-sm text-muted-foreground">
              <div className="flex items-center gap-2"><MapPin size={14} className="text-[#C9A962]" /><span>www.elrincondecamo.com</span></div>
              <div className="flex items-center gap-2"><Clock size={14} className="text-[#C9A962]" /><span>{t('footer.hours')}</span></div>
              <div className="flex items-center gap-2"><Mail size={14} className="text-[#C9A962]" /><span>info@elrincondecamo.com</span></div>
            </div>
          </div>
          <div>
            <h4 className="text-[#C9A962] font-semibold mb-4 text-sm uppercase tracking-wider" style={{ fontFamily: 'Cinzel, serif' }}>
              {t('footer.store')}
            </h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/store?category=board_game" className="hover:text-foreground transition-colors">{t('footer.board_games')}</Link></li>
              <li><Link to="/store?category=tcg" className="hover:text-foreground transition-colors">TCG</Link></li>
              <li><Link to="/store?category=accessory" className="hover:text-foreground transition-colors">{t('footer.accessories')}</Link></li>
              <li><Link to="/cart" className="hover:text-foreground transition-colors">{t('nav.cart')}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-[#C9A962] font-semibold mb-4 text-sm uppercase tracking-wider" style={{ fontFamily: 'Cinzel, serif' }}>
              {t('footer.community')}
            </h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/reservations/games" className="hover:text-foreground transition-colors">{t('footer.reserve_game')}</Link></li>
              <li><Link to="/reservations/tables" className="hover:text-foreground transition-colors">{t('footer.reserve_table')}</Link></li>
              <li><Link to="/events" className="hover:text-foreground transition-colors">{t('nav.events')}</Link></li>
              <li><Link to="/torneos" className="hover:text-foreground transition-colors">{t('nav.tournaments')}</Link></li>
              <li><Link to="/collections" className="hover:text-foreground transition-colors">{t('nav.collections')}</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-border mt-8 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-muted-foreground text-xs">© 2025 El Rincón de Camo. {t('footer.rights')}</p>
          <div className="flex gap-1">
            <div className="w-2 h-2 rounded-full bg-[#0D5E4A]"></div>
            <div className="w-2 h-2 rounded-full bg-[#C9A962]"></div>
            <div className="w-2 h-2 rounded-full bg-[#2D8B70]"></div>
          </div>
        </div>
      </div>
    </footer>
  );
}
